var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loader" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.message
      ? _c("div", {
          staticClass: "message blue-text",
          domProps: { textContent: _vm._s(_vm.message) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preloader-wrapper big active" }, [
      _c("div", { staticClass: "spinner-layer spinner-blue-only" }, [
        _c("div", { staticClass: "circle-clipper left" }, [
          _c("div", { staticClass: "circle" })
        ]),
        _c("div", { staticClass: "gap-patch" }, [
          _c("div", { staticClass: "circle" })
        ]),
        _c("div", { staticClass: "circle-clipper right" }, [
          _c("div", { staticClass: "circle" })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }